import className from 'classnames/bind';
import { Heading, Container } from '../../components';
import { useInView } from '../../hooks';
import styles from './EntryHeaderFaq.module.scss';

let cx = className.bind(styles);

export default function EntryHeaderFaq({ title, longDescription, className, smallHeader }) {
  const hasText = title || longDescription;
  const [headerRef, isHeaderInView] = useInView({ threshold: 0.2 });

  return (
    <div 
      ref={headerRef}
      className={cx([
        'component', 
        className, 
        { 'animate': isHeaderInView }
      ])}
    >
      {hasText && (
        <div className={cx('text')}>
          <Container>
            {smallHeader && (
              <span className={cx('smallHeader', { 'animate': isHeaderInView })}>
                {smallHeader}
              </span>
            )}
            {!!title && (
              <Heading className={cx('title', { 'animate': isHeaderInView })}>
                {title}
              </Heading>
            )}
            {!!longDescription && (
              <div 
                className={cx('description', { 'animate': isHeaderInView })}
                dangerouslySetInnerHTML={{ __html: longDescription }}
              />
            )}
          </Container>
        </div>
      )}
    </div>
  );
} 